import { render, staticRenderFns } from "./dialogEventSub.vue?vue&type=template&id=7b448b70&"
import script from "./dialogEventSub.vue?vue&type=script&lang=js&"
export * from "./dialogEventSub.vue?vue&type=script&lang=js&"
import style0 from "./dialogEventSub.vue?vue&type=style&index=0&id=7b448b70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports